import { useQuery } from "@tanstack/react-query";
import laptopApi from "../../api/laptopApi";

interface GetLaptopParams {
    page?: number;
    limit?: number;
    status?: string;
}

interface LaptopListData {
    items: any[];
    meta: {
        totalItems: number;
        itemCount: number;
        itemsPerPage: number;
        totalPages: number;
        currentPage: number;
    };
}

export const useGetAllLaptop = (params: GetLaptopParams) => {
    return useQuery<LaptopListData>({
        queryKey: ["laptop-list", params],
        queryFn: () => laptopApi.getAllLaptop(params).then((res: any) => res.data ?? res),
        placeholderData: (prev) => prev,
    });
};